<template>
  <div class="container-fluid">
    <TableControls @searchterm="filterUsers($event)" :canSearch="true"/>
    <div class="row">
      <div class="col-md-12">
        <BaseTable
          :columns="columns"
          :tableData="users"
          :pagination="pagination"
          :paginationParams="index"
          :indexCallback="getUsers"
        >
          <span slot="name" slot-scope="{ row }">
            <router-link :to="`/users/edit/${row.uuid}`">{{row.first_name}} {{row.last_name}}</router-link>
          </span>
          <span slot="delete" slot-scope="{ row }">
            <i class="fas fa-trash-alt pointer" @click="showDeleteModal(row)"></i>
          </span>
        </BaseTable>
      </div>
    </div>
    <Modal v-if="userModal">
      <h3 slot="header">User {{ modalInformation.name }}</h3>
      <p slot="body">Are you sure you want to delete this User?</p>
      <div slot="footer">
        <button class="blueBtn smBtn" @click="deleteUser(modalInformation)">Delete</button>
        <button class="greyBtn smBtn ml-1" @click="userModal = false">Cancel</button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Users from '@/resources/Users.js'

export default {
  data () {
    return {
      users: [],
      userModal: false,
      modalInformation: null,
      columns: [
        { name: 'Full Name', key: 'name', class: 'col-md-2' },
        { name: 'Email', key: 'email', class: 'col-md-3' },
        { name: 'Updated At', key: 'updated_at', class: 'col-md-3', filter: 'date' },
        { name: 'Created At', key: 'created_at', class: 'col-md-3', filter: 'date' },
        { name: 'Delete', key: 'delete', class: 'col-md-1 text-center' }
      ],
      index: {
        limit: 10,
        page: 1,
        total: null
      },
      pagination: {}
    }
  },
  mounted () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      Users.index()
        .then((res) => {
          if (res.error && res.status === 422) {
            this.$toast(res.msg, { error: true })
          } else if (!res.error) {
            this.users = res.data
          }
        })
    },
    filterUsers (term) {
      Users.filter(term).then(res => {
        if (res.error && res.status === 422) {
          this.$toast('There are no users with that name', { error: true })
          this.getUsers()
        } else {
          this.pagination = res
          this.users = res.data
        }
      })
    },
    deleteUser (user) {
      const id = user.uuid
      Users.destroy(id).then(res => {
        if (res.error && res.status === 422) {
          this.$toast(res.msg, { error: true })
        } else if (!res.error) {
          this.$toast(res.message)
          this.getUsers()
        }
        this.userModal = false
      })
    },
    showDeleteModal (user) {
      this.modalInformation = user
      this.userModal = true
    }
  },
  computed: {},
  components: {}
}
</script>
<style lang="scss">
</style>
